import apiClient from './client';

// ─── Typen ──────────────────────────────────────────────────────────────────

export interface Statistics {
  overview: {
    totalPersons: number;
    totalFamilies: number;
    totalGenerations: number;
    oldestPerson: { name: string; age: number } | null;
    youngestBirth: { name: string; year: number } | null;
  };
  genderDistribution: { gender: string; count: number }[];
  ageDistribution: { bracket: string; count: number }[];
  averageAge: number | null;
  topBirthPlaces: { place: string; count: number }[];
  topDeathPlaces: { place: string; count: number }[];
  birthPlacePie: { label: string; count: number }[];
  birthCountryPie: { label: string; count: number }[];
  topLastNames: { name: string; count: number }[];
  birthsByDecade: { decade: string; count: number }[];
  deathsByDecade: { decade: string; count: number }[];
  childrenPerFamily: {
    average: number;
    max: { count: number; parents: string } | null;
    distribution: { children: number; families: number }[];
  };
  averageMarriageAge: number | null;
  marriageAgeByDecade: { decade: string; avgAge: number }[];
  lifeExpectancyByDecade: { decade: string; avgAge: number; count: number }[];
  migrations: { from: string; to: string; count: number }[];
  topFirstNames: { name: string; count: number }[];
  occupationStats: {
    personsWithOccupation: number;
    totalStations: number;
    distinctTitles: number;
    topOccupations: { title: string; count: number }[];
    byGender: { title: string; male: number; female: number; other: number }[];
    byPeriod: { period: string; topTitles: { title: string; count: number }[] }[];
  };
  funFacts: { icon: string; title: string; value: string; detail?: string }[];
}

// ─── API ────────────────────────────────────────────────────────────────────

export async function getStatistics(): Promise<Statistics> {
  const { data } = await apiClient.get<Statistics>('/statistics');
  return data;
}
